/**
 * Scene component extracted from MineGameScene
 */

class MineGameSceneComponent extends ScriptComponent {
    onCreate() {
        this.sceneOptions = (PrefabBuilder.resolveProperty(this.options.args, this.context) || [])[0] || {};
        this.styles = PrefabBuilder.resolveProperty(this.options.styles, this.context);
    }

    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);

        this.sceneComponent.setStyling({
            bundle: "minesweeper",
            backgroundId: "background",
            animation: bundles.minesweeper.jsons.bg_json
        });
        this.sceneComponent.setAudioStyles({
            res: bundles.minesweeper.urls.mine_music,
            delay: 1.0
        });
        this.sceneComponent.setBundles(["minesweeper"]);
    }

    onSceneLoaded() {
        this.mineGame = new MineSweeper(this.sceneOptions);

        this.mineGame.on("win", this.gameFinish.bind(this), this.node);
        this.mineGame.on("lose", this.onLose.bind(this), this.node);
        this.mineGame.on("victory", this.onVictory.bind(this), this.node);
        this.mineGame.on("askContinue", this.askContinue.bind(this), this.node);
        this.mineGame.on("open", this.onCellOpen.bind(this), this.node);
        this.mineGame.on("resumed", this.onResumed.bind(this), this.node);
        this.mineGame.on("bomb", this.onBomb.bind(this), this.node);

        cleverapps.metrics.logEvent(cleverapps.EVENTS.MINESWEEPER_START);
    }

    onReady() {
        this.gameNode = ComponentUtils.findChildByName(this.node, "gameNode");
        this.person = ComponentUtils.findChildByName(this.node, "person");

        this.onResize();
    }

    buildGuideButton() {
        return new cleverapps.UI.HelpButton({
            callback: function () {
                cleverapps.focusManager.display({
                    focus: "GuideMine",
                    action: function (f) {
                        new GuideWindow(MineGuideOptions);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        });
    }

    buildGameNode() {
        return new MineSweeperNode(this.mineGame);
    }

    buildPerson() {
        const injected = bundles.minesweeper.jsons.personLeft;
        const person = new Person(injected ? { json: injected } : { role: "miner", forWindow: true });
        person.setLocalZOrder(1);
        person.setVisible(cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL);
        return person;
    }

    onVictory() {
        this.person.runAction(new cc.Sequence(
            new cc.MoveBy(0.2, cc.p(0, -this.person.height * this.person.scale)),
            new cc.RemoveSelf()
        ));
    }

    onLose(f) {
        new MineVictoryWindow({
            reward: this.mineGame.reward,
            lose: true
        });
        cleverapps.focusManager.onceNoWindowsListener = f;
    }

    askContinue(options) {
        let isContinued = false;
        cleverapps.focusManager.display({
            focus: "loseMine",
            actions: [
                function (f) {
                    cleverapps.timeouts.setTimeout(f, 500);
                },
                function (f) {
                    new MineContinueWindow({
                        reward: this.mineGame.reward,
                        callback: function () {
                            isContinued = true;
                        }
                    });
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }.bind(this),

                function (f) {
                    if (isContinued) {
                        this.mineGame.resume();
                        f();
                    } else {
                        this.mineGame.lose(f, options);
                    }
                }.bind(this)
            ]
        });
    }

    gameFinish() {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.MINESWEEPER_VICTORY);
        cleverapps.effects.fire("minesweeper.win");
        this.person.setAnimation(0, "happy", true);

        cleverapps.focusManager.display({
            focus: "VictoryMine",
            actions: [
                function (f) {
                    cleverapps.timeouts.setTimeout(f, 1000);
                },

                function (f) {
                    new MineVictoryWindow({
                        reward: this.mineGame.reward
                    });
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }.bind(this)
            ]
        });
    }

    onResize() {
        this.person.setVisible(cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL);
    }

    onAfterResize() {
        cleverapps.UI.inflateToBoundaries(this.gameNode, [], {
            maxScale: 1,
            padding: this.styles.padding
        });
        this.gameNode.setAlignment(this.styles.minigame);
    }

    onCellOpen(options) {
        if (this.person.isVisible()) {
            this.person.setAnimationAndIdleAfter(options.bomb ? "yank" : "happy", "idle");
        }
    }

    onResumed() {
        this.person.setAnimationAndIdleAfter("happy", "idle");
        cleverapps.effects.fire("minesweeper.continue.buy");
        cleverapps.effects.fire("minesweeper.miner.good");
    }

    onBomb() {
        this.node.runAction(new cc.Sequence(
            new cc.DelayTime(1),
            new cc.CallFunc(() => {
                this.person.setAnimationAndIdleAfter("explosion", "sad");
                cleverapps.effects.fire("minesweeper.bomb");
            })
        ));
    }

    onCloseAction() {
        let shouldExit = false;

        cleverapps.focusManager.display({
            focus: "ConfirmMineExit",
            actions: [
                function (f) {
                    const mineReward = this.mineGame.reward || {};
                    new ConfirmExitWindow({
                        text: Messages.get("ConfirmExitWindow.text"),
                        reward: Object.values(mineReward).some(Boolean) ? {
                            hard: 0,
                            soft: 0,
                            energy: 0,
                            ...mineReward
                        } : undefined,
                        action: function () {
                            shouldExit = true;
                        }
                    });

                    cleverapps.focusManager.onceNoWindowsListener = f;
                }.bind(this),

                function (f) {
                    if (!shouldExit) {
                        f();
                        return;
                    }

                    if (!this.mineGame.reward) {
                        this.mineGame.saver.add({
                            reward: { canceled: true }
                        });
                    }

                    cleverapps.meta.gotoMainLocation(f);
                }.bind(this)
            ]
        });

        return true;
    }
}

Prefab.registerComponent("MineGameSceneComponent", MineGameSceneComponent);
